"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** A promisified animation frame. */
function animationFrame() {
    return new Promise((resolve) => requestAnimationFrame(resolve));
}
exports.default = animationFrame;
